import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import TopBar from './TopBar';
import ErrorBoundary from '@components/ErrorBoundary';
import { useUIStore } from '@store/uiStore';

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Bar - full width purple header */}
      <TopBar />

      {/* Sidebar - positioned below top bar */}
      <Sidebar />

      {/* Main content area - offset for top bar and sidebar */}
      <div
        className={`pt-14 transition-all duration-300 ${
          sidebarCollapsed ? 'lg:ml-sidebar-collapsed' : 'lg:ml-sidebar'
        }`}
      >
        {/* Header */}
        <Header />

        {/* Page content with error boundary */}
        <main className="p-4 sm:p-6">
          <ErrorBoundary>
            {children}
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
